/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-01-15 14:04:15
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-10-19 15:25:38
 * @FilePath: \crm-product\found\views\sfa\views\reports\banquet_present\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import TablePage from '@/found/components/table_page';
import Form from './form/index';
import scanDetails from './scan_details';

export default {
  name: 'table-component',
  extends: TablePage,
  components: { Form, scanDetails },
  data() {
    return {};
  },
  methods: {
    modalClick({ val, row }) {
      if (val.code === 'view') {
        this.formName = 'Form';
        this.modalConfig.title = '详情';
        this.openFull();
        this.formConfig = {
          code: val.code,
          row,
        };
      }
      if (val.code === 'scan_details') {
        this.modalConfig.title = '扫码明细';
        this.formName = 'scanDetails';
        this.propsObjInData.row = row;
        // this.openDrawer();
        this.openFull();
      }
    },
  },
  created() {
    this.getConfigList('banquet_present_list');
  },

};
